import Services from './index';
import {
  LOAD_DIALOG_URL,
  LOAD_DIALOG_DETAIL_URL,
  SAVE_DIALOG_URL,
  FLUSH_CONVERSATION_URL,
  AI_TESTING_URL,
  GET_STATS_DIALOG_URL,
} from 'consts/api';
import { momentInstance } from 'helpers/date-time';
import { FORMAT_STATS } from 'consts/data';

class ResponderServices {
  getListDialogs({ published, filters }) {
    const bodyLoadInBox = {
      published,
      ...filters,
    };
    return Services.post(LOAD_DIALOG_URL, bodyLoadInBox);
  }

  getDialogDetail(idResponder) {
    return Services.post(`${LOAD_DIALOG_DETAIL_URL}?id=${idResponder}`);
  }

  switchResponder(body) {
    return Services.post(SAVE_DIALOG_URL, body);
  }

  createResponder(body) {
    return Services.post(SAVE_DIALOG_URL, body);
  }

  setDidResponder({
    id,
    title,
    userId,
    contactGroupId,
    contactGroupName,
    status,
    created,
    type,
    published,
    cost,
    didGroupId,
  }) {
    return Services.post(SAVE_DIALOG_URL, {
      id,
      title,
      userId,
      contactGroupId,
      contactGroupName,
      status,
      created,
      type,
      published,
      cost,
      didGroupId,
    });
  }

  flushConversationHistory(contactGroupId) {
    return Services.post(`${FLUSH_CONVERSATION_URL}?contactGroupId=${contactGroupId}`);
  }

  loadMoreResponder({ published, filters }) {
    return Services.post(LOAD_DIALOG_URL, {
      published,
      ...filters,
    });
  }

  AiTesting({ text = '', type = '' }, configs) {
    return Services.post(AI_TESTING_URL, { text, type }, configs);
  }

  getStatsDialog({ dialogId, from, to }) {
    const fromDate = momentInstance(from).format(FORMAT_STATS);
    const toDate = momentInstance(to).format(FORMAT_STATS);

    return Services.post(GET_STATS_DIALOG_URL, { dialogId, from: fromDate, to: toDate });
  }
}

export default new ResponderServices();
